/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_Created_FromInputs */

const cs_blog_filter_created_from = /** @type {(inputs: Blog_Filter_Created_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořeno od`)
};

const en_blog_filter_created_from = /** @type {(inputs: Blog_Filter_Created_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created from`)
};

/**
* | output |
* | --- |
* | "Created from" |
*
* @param {Blog_Filter_Created_FromInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_created_from = /** @type {((inputs?: Blog_Filter_Created_FromInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_Created_FromInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_created_from(inputs)
	return cs_blog_filter_created_from(inputs)
});